import styled from 'styled-components';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';

const defineSize = (size, type) => {
	const fontSize = `var(--font-size-${size.toLowerCase().replace('t', '')})`;
	const lineHeight = `var(--font-line-height-${size.toLowerCase().replace('t', '')})`;
	const paragraphMarginBottom = `var(--spacing-paragraph-margin-bottom-${size.toLowerCase()})`;

	return `font-size: ${fontSize};
            line-height: ${lineHeight};
            margin-bottom: ${type === 'paragraph' ? paragraphMarginBottom : ''};`;
};

const StyledTypography = styled.h1`
	${({ color, type, size }) => {
		const typographyColour = color || `var(--color-font-${type})`;
		const viewportSizes =
			typeof size === 'string' || size instanceof String
				? defineSize(size, type)
				: ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']
					.filter((viewport) => size[viewport])
					.map(
						(viewport) => `@media screen and (min-width: ${gridConfig[viewport].minWidth}) {
                        ${defineSize(size[viewport], type)}
                    }`,
					)
					.join('');

		return `
            color: ${typographyColour};
            font-weight: var(--font-weight-${type});

            ${viewportSizes}

            a {
                color: var(--color-global-black);

                &:active,
                &:focus {
                    outline: 2px solid var(--color-functional-focus);
                }

                &:visited {
                    color: var(--color-global-grey800);
                }

                &:visited:hover,
                &:visited:focus,
                &:hover,
                &:focus {
                    color: var(--color-brand-dark);
                }

                &:active,
                &:visited:active {
                    color: var(--color-global-black);
                }
            }
        `;
	}}
`;

export default StyledTypography;
